export default "__VITE_ASSET__CKDHvpOq__"